module.exports = __webpack_public_path__ + "static/media/front.927c1b83.png";